import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e092644"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "topbox" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "top_notice_sview" }
const _hoisted_5 = { class: "notice" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "suipian_left" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "suipian_right" }
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  class: "exchange_area",
  ref: "exchangeRef"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "exchange_area_title" }
const _hoisted_17 = { class: "goods_div1" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "goods_sview" }
const _hoisted_20 = { class: "prizeNameClass" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "suipianCount_sview" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { style: {"color":"white","font-size":"12px","font-weight":"600"} }
const _hoisted_25 = { class: "goods_div2" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "goods_sview" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "suipianCount_sview" }
const _hoisted_30 = ["src"]
const _hoisted_31 = { style: {"color":"white","font-size":"12px","font-weight":"600"} }
const _hoisted_32 = { class: "everyday" }
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "everyday_title" }
const _hoisted_35 = { class: "everyday_content" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "zhuanpan_count" }
const _hoisted_38 = { style: {"color":"white","font-size":"12px","font-weight":"600"} }
const _hoisted_39 = {
  ref: "ruleSection",
  class: "activeRuleBg"
}
const _hoisted_40 = ["src"]
const _hoisted_41 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.showTopBar)
      ? (_openBlock(), _createBlock(_component_van_nav_bar, {
          key: 0,
          title: "SPIN HOKI",
          "left-arrow": "",
          onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.ToBack($setup.router)))
        }))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", { src: $setup.lottery_bg_icon }, null, 8 /* PROPS */, _hoisted_3),
        _createCommentVNode(" 中奖通知栏 "),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", { src: $setup.notice_bg_icon }, null, 8 /* PROPS */, _hoisted_6),
            _createElementVNode("span", null, _toDisplayString($setup.notice), 1 /* TEXT */)
          ]),
          _createElementVNode("label", {
            class: "rule",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.ruleClick()))
          }, _toDisplayString(_ctx.$t('规则')), 1 /* TEXT */)
        ]),
        _createCommentVNode(" logo图片 "),
        _createCommentVNode(" <img :src=\"app_logo\" class=\"logo_class\"> "),
        _createCommentVNode(" 左侧获得碎片数量 "),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("img", { src: $setup.suipian_top }, null, 8 /* PROPS */, _hoisted_8),
          _createElementVNode("img", { src: $setup.suipian_bottom }, null, 8 /* PROPS */, _hoisted_9),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('碎片')), 1 /* TEXT */),
          _createElementVNode("span", null, _toDisplayString($setup.suipianCount), 1 /* TEXT */)
        ]),
        _createCommentVNode(" 抽奖按钮 "),
        _createElementVNode("div", {
          class: _normalizeClass(["start_click", { zooming: $setup.zooming }]),
          onClick: $setup.startSpin
        }, [
          _createElementVNode("img", { src: $setup.click_text }, null, 8 /* PROPS */, _hoisted_10)
        ], 2 /* CLASS */),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("img", { src: $setup.zhuanpan_top }, null, 8 /* PROPS */, _hoisted_12),
          _createElementVNode("img", { src: $setup.zhuanpan_bottom }, null, 8 /* PROPS */, _hoisted_13),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('转盘次数')), 1 /* TEXT */),
          _createElementVNode("span", null, _toDisplayString($setup.spinCount), 1 /* TEXT */)
        ]),
        _createElementVNode("div", {
          class: "duihuan_title",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.moveToExchangeArea()))
        }, _toDisplayString(_ctx.$t('奖品兑换')), 1 /* TEXT */),
        _createCommentVNode(" 轮盘区域 "),
        _createVNode($setup["SpinPointerComponent"], {
          ref: "spinRef",
          pointerImg: $setup.pointerImg,
          onFinished: $setup.handlePrize,
          highlightImg: $setup.highlightSectorImg,
          prizeList: $setup.prizeLunboList,
          class: "spin-area"
        }, null, 8 /* PROPS */, ["pointerImg", "highlightImg", "prizeList"])
      ]),
      _createCommentVNode(" 奖品兑换区 "),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("img", {
          src: $setup.exchange_bg_icon,
          class: "exchange_area_bgimg"
        }, null, 8 /* PROPS */, _hoisted_15),
        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('奖品兑换')), 1 /* TEXT */),
        _createCommentVNode(" 第一行 "),
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.prizeList0, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.sku,
              class: "goods_row1"
            }, [
              _createElementVNode("img", {
                src: $setup.goods1_bg,
                class: "goods_bg"
              }, null, 8 /* PROPS */, _hoisted_18),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(item.name), 1 /* TEXT */),
                _createElementVNode("img", {
                  src: item.cover,
                  class: "goods"
                }, null, 8 /* PROPS */, _hoisted_21),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("img", { src: $setup.suipian }, null, 8 /* PROPS */, _hoisted_23),
                  _createElementVNode("span", null, _toDisplayString(item.price), 1 /* TEXT */)
                ]),
                _createVNode(_component_van_button, {
                  style: {"margin-top":"5px","width":"97px","height":"20px","background":"linear-gradient(to bottom, rgba(255, 119, 83, 1), rgba(242, 66, 24, 1))"},
                  onClick: ($event: any) => ($setup.claimPrizeWithIndex(index)),
                  round: "",
                  disabled: $setup.duihuanButtonStatus(item)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_24, _toDisplayString($setup.getPrizeStatusText(item)), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "disabled"])
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createCommentVNode(" 第二行 "),
        _createElementVNode("div", _hoisted_25, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.prizeList1, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: "item.sku",
              class: "goods_row2",
              style: _normalizeStyle({width: `calc((100% - ${($setup.prizeList1.length - 1) * 8}px) / ${$setup.prizeList1.length})`})
            }, [
              _createElementVNode("img", {
                src: index % 2 ? $setup.goods2_bg : $setup.goods3_bg ,
                class: "goods_bg"
              }, null, 8 /* PROPS */, _hoisted_26),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("img", {
                  src: item.cover,
                  class: "goods"
                }, null, 8 /* PROPS */, _hoisted_28),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("img", { src: $setup.suipian }, null, 8 /* PROPS */, _hoisted_30),
                  _createElementVNode("span", null, _toDisplayString(item.price), 1 /* TEXT */)
                ]),
                _createVNode(_component_van_button, {
                  style: {"margin-top":"5px","width":"97px","height":"20px","background":"linear-gradient(to bottom, rgba(255, 119, 83, 1), rgba(242, 66, 24, 1))"},
                  onClick: ($event: any) => ($setup.claimPrizeWithIndex(index + 2)),
                  round: "",
                  disabled: $setup.duihuanButtonStatus(item)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_31, _toDisplayString($setup.getPrizeStatusText(item)), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "disabled"])
              ])
            ], 4 /* STYLE */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createCommentVNode(" <div class=\"exchange_goods\"> "),
        _createCommentVNode(" <div>\n                    <img :src=\"goods1_bg\" class=\"goods_bg\">\n                    <div class=\"goods_sview\">\n                        <span class=\"prizeNameClass\">{{ prize0.name }}</span>\n                        <img :src=\"prize0.cover\" class=\"goods\">\n                        <div class=\"suipianCount_sview\">\n                            <img :src=\"suipian\">\n                            <span>{{ prize0.price }}</span>\n                        </div>\n                        <van-button\n                            style=\"margin-top: 5px; width: 97px; height: 20px;background: linear-gradient(to bottom, rgba(255, 119, 83, 1), rgba(242, 66, 24, 1));\"\n                            @click=\"claimPrizeWithIndex(0)\" round :disabled=\"duihuanButtonStatus(prize0)\">\n                            <span style=\"color: white; font-size: 12px; font-weight: 600;\">{{ getPrizeStatusText(prize0)\n                                }}</span>\n                        </van-button>\n                    </div>\n                </div>\n                <div>\n                    <img :src=\"goods1_bg\" class=\"goods_bg\">\n                    <div class=\"goods_sview\">\n                        <span class=\"prizeNameClass\">{{ prize1.name }}</span>\n                        <img :src=\"prize1.cover\" class=\"goods\">\n                        <div class=\"suipianCount_sview\">\n                            <img :src=\"suipian\">\n                            <span>{{ prize1.price }}</span>\n                        </div>\n                        <van-button\n                            style=\"margin-top: 5px; width: 97px; height: 20px;background: linear-gradient(to bottom, rgba(255, 119, 83, 1), rgba(242, 66, 24, 1));\"\n                            @click=\"claimPrizeWithIndex(1)\" round :disabled=\"duihuanButtonStatus(prize1)\">\n                            <span style=\"color: white; font-size: 12px; font-weight: 600;\">{{ getPrizeStatusText(prize1)\n                                }}</span>\n                        </van-button>\n                    </div>\n                </div> "),
        _createCommentVNode(" <div>\n                    <div>\n                        <img :src=\"goods2_bg\" class=\"goods_bg\">\n                        <div class=\"goods_sview\">\n                            <img :src=\"prize2.cover\" class=\"goods\">\n                            <div class=\"suipianCount_sview\">\n                                <img :src=\"suipian\">\n                                <span>{{ prize2.price }}</span>\n                            </div>\n                            <van-button\n                                style=\"margin-top: 5px; width: 97px; height: 20px;background: linear-gradient(to bottom, rgba(255, 119, 83, 1), rgba(242, 66, 24, 1));\"\n                                @click=\"claimPrizeWithIndex(2)\" round :disabled=\"duihuanButtonStatus(prize2)\">\n                                <span style=\"color: white; font-size: 12px; font-weight: 600;\">{{\n                                    getPrizeStatusText(prize2) }}</span>\n                            </van-button>\n                        </div>\n                    </div>\n                    <div>\n                        <img :src=\"goods3_bg\" class=\"goods_bg\">\n                        <div class=\"goods_sview\">\n                            <img :src=\"prize3.cover\" class=\"goods\">\n                            <div class=\"suipianCount_sview\">\n                                <img :src=\"suipian\">\n                                <span>{{ prize3.price }}</span>\n                            </div>\n                            <van-button\n                                style=\"margin-top: 5px; width: 97px; height: 20px;background: linear-gradient(to bottom, rgba(255, 119, 83, 1), rgba(242, 66, 24, 1));\"\n                                @click=\"claimPrizeWithIndex(3)\" round :disabled=\"duihuanButtonStatus(prize3)\">\n                                <span\n                                    style=\"white-space: nowrap; display: inline-block; width: 97px; height: 20px; color: white; font-size: 12px; font-weight: 600;\">{{\n                                        getPrizeStatusText(prize3) }}</span>\n                            </van-button>\n                        </div>\n                    </div>\n                </div> "),
        _createCommentVNode(" </div> ")
      ], 512 /* NEED_PATCH */),
      _createCommentVNode(" 前往积分商城 "),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("img", {
          src: $setup.everyday_bg_icon,
          class: "everyday_bg_img"
        }, null, 8 /* PROPS */, _hoisted_33),
        _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('兑换奖励')), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("img", { src: $setup.exchangeGoods }, null, 8 /* PROPS */, _hoisted_36),
          _createElementVNode("div", null, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('前往JalaLive积分商城')), 1 /* TEXT */),
            _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('积分可以去兑换商品')), 1 /* TEXT */)
          ]),
          _createVNode(_component_van_button, {
            style: {"margin-top":"5px","width":"81px","height":"25px","background":"linear-gradient(to bottom, rgba(255, 119, 83, 1), rgba(242, 66, 24, 1))"},
            onClick: $setup.getEverydayReward,
            round: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('前往')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createCommentVNode(" <span class=\"everyday_get\">领取</span> ")
        ])
      ]),
      _createCommentVNode(" 活动规则 "),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("img", { src: $setup.activeRulebg }, null, 8 /* PROPS */, _hoisted_40),
        _createElementVNode("div", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('活动规则')), 1 /* TEXT */)
        ])
      ], 512 /* NEED_PATCH */),
      _createElementVNode("div", {
        innerHTML: $setup.rule_html,
        class: "v-htmlclass"
      }, null, 8 /* PROPS */, _hoisted_41)
    ]),
    _createVNode(_component_van_dialog, {
      show: $setup.showComfirmAlert,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (($setup.showComfirmAlert) = $event)),
      title: _ctx.$t('确认兑换吗？'),
      "show-cancel-button": "",
      lockScroll: "",
      "confirm-button-text": $setup.t('me.ok'),
      "cancel-button-text": $setup.t('tips.cancel'),
      "before-close": $setup.beforeSubmitClose1
    }, null, 8 /* PROPS */, ["show", "title", "confirm-button-text", "cancel-button-text"]),
    ($setup.showResult)
      ? (_openBlock(), _createBlock($setup["PrizeResultModal"], {
          key: 1,
          visible: $setup.showResult,
          "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (($setup.showResult) = $event)),
          prizeIcon: $setup.prizeResult.cover,
          prizeTitle: $setup.prizeResult.sku == $setup.XXHG ? _ctx.$t('谢谢惠顾') : _ctx.$t('恭喜您获得'),
          prizeName: $setup.prizeResult.name,
          class: "showResultClass"
        }, null, 8 /* PROPS */, ["visible", "prizeIcon", "prizeTitle", "prizeName"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}